import { getPrivySessionBridge } from '../session-bridge'
import { isPrivyReadyVar } from '../store'

/**
 * Opens the Privy login modal from anywhere in the Privy-free UI (FE-302):
 * header button, game buttons for guests, the demo quota, the referral link,
 * the "sign in" page.
 *
 * The Privy chunk loads lazily, so a click that lands before the session
 * bridge is registered waits for it instead of being dropped.
 */
export const openPrivyLogin = () => {
  const bridge = getPrivySessionBridge()
  if (bridge) {
    bridge.login()
    return
  }

  const unsubscribe = isPrivyReadyVar.onNextChange(isReady => {
    unsubscribe()
    if (isReady) openPrivyLogin()
  })
}
